module.exports = __webpack_public_path__ + "1faa16c81210947a450d5057346c92dd.svg";